import { RoutePath } from 'src/data/Routes';
import type { ToolSection } from 'src/routing/RouteToolSections';

export const EXPORTER_SECTIONS = [
  { key: 'exporter-exports', path: '/exports', title: 'Exports', isLeaf: true },
  { key: 'exporter-email', path: '/email', title: 'Email', isLeaf: true },
] as const satisfies readonly ToolSection[];

export type ExporterSectionPath = typeof EXPORTER_SECTIONS[number]['path'];

export const EXPORTER_SECTION_DEFAULT = RoutePath.EXPORTER + EXPORTER_SECTIONS[0].path;
